import { dateHeader, formatCellDate, timeModeName } from './timeModeCell';
import GridAction from '../../components/common/GridAction';
import { ViewTimelineTwoTone } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { AppPermissions } from '../../constants/Permissions';
import { ResourceType } from '../../types/ResourceType';
import { Label } from '../../types/Label';

export const makeLabelListColumn = (onDeleted: (id: string) => void, onEdit: (label: Label) => void, onOpenChangeLog: (id: string) => void) => {
  return [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={onEdit}
            editPermission={AppPermissions.Label.Edit}
            onDeleted={onDeleted}
            deletePermission={AppPermissions.Label.Delete}
            row={row.original}
            id={row.original.id}
          >
            {' '}
            <Tooltip style={{ cursor: 'pointer' }} title='Show Changelog' disableInteractive onClick={() => onOpenChangeLog(row.original.id)}>
              <ViewTimelineTwoTone fontSize='small' />
            </Tooltip>
          </GridAction>
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 350,
    },
    {
      id: 'resourceType',
      header: () => <div style={{ textAlign: 'center' }}>Type</div>,
      accessorKey: 'resourceType',
      enableColumnFilter: false,
      size: 90,
      style: { textAlign: 'center' },
      cell: ({ row }) => (ResourceType[row.original.resourceType] ? ResourceType[row.original.resourceType] : 'No resource type'),
    },
    {
      id: 'colorRgb',
      header: () => <div style={{ textAlign: 'center' }}>Color</div>,
      accessorKey: 'colorRgb',
      enableColumnFilter: false,
      size: 90,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return <span style={{ color: row.original.colorRgb }}>{row.original.colorRgb}</span>;
      },
    },
    {
      id: 'createdUserName',
      header: () => <div style={{ textAlign: 'center' }}>Created By</div>,
      accessorKey: 'createdUserName',
      size: 110,
    },
    {
      id: 'createdDateTime',
      header: ({ table }) => <div style={{ textAlign: 'center' }}>Created ({timeModeName(table)})</div>,
      accessorKey: 'createdDateTime',
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      id: 'modifiedUserName',
      header: () => <div style={{ textAlign: 'center' }}>Modified By</div>,
      accessorKey: 'modifiedUserName',
      size: 110,
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;
};
